import { motion } from 'framer-motion';

export default function BackgroundEffects() {
  return (
    <div
      className="fixed inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: -1 }}
      aria-hidden="true"
    >
      {/* Large soft blue glow, bottom-left — the page's main ambient light source */}
      <motion.div
        animate={{ opacity: [0.5, 0.7, 0.5] }}
        transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
        style={{
          position: 'absolute',
          bottom: '-15%',
          left: '-10%',
          width: '1100px',
          height: '800px',
          borderRadius: '50%',
          background:
            'radial-gradient(ellipse at center, rgba(14,165,233,0.22) 0%, rgba(14,165,233,0.08) 45%, transparent 72%)',
          filter: 'blur(100px)',
        }}
      />

      {/* Faint high glow, top-right — adds depth without competing with the bottom-left source */}
      <motion.div
        animate={{ opacity: [0.25, 0.4, 0.25] }}
        transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
        style={{
          position: 'absolute',
          top: '-10%',
          right: '-10%',
          width: '800px',
          height: '600px',
          borderRadius: '50%',
          background: 'radial-gradient(ellipse at center, rgba(56,189,248,0.14) 0%, transparent 70%)',
          filter: 'blur(90px)',
        }}
      />
    </div>
  );
}
